<script setup>
import { watch, ref, onMounted, nextTick } from 'vue'
import { useRoute } from 'vue-router'

const version = __APP_VERSION__
const searchTerm = ref('')
const showResults = ref(false)
const noResults = ref(true)
const isFocused = ref(false)
const searchContainer = ref(null)
const indName = ref('')
const apiUrl = import.meta.env.VITE_API_URL;
const baseUrl =  import.meta.env.VITE_BASE_URL

const route = useRoute()

//properties set by parent
const props = defineProps({
	indName: {
		type: String,
		required: false,
	}
})

function resultToSingleObj(data) {
	let records = [];
	let results = [];
	let matches = [];
	/* combine */
	/* no need to combine - only going to display indicators: */
	/*
	if(data.topics.results && data.topics.results.length > 0) {
		data.topics.results[0].forEach ((item) => {
			records.push(item + '||');
		})
		if(data.topics.matches) {
			matches.push(...data.topics.matches);
		}
	}
	if(data.subTopics.results && data.subTopics.results.length > 0) {
		data.subTopics.results[0].forEach ((item) => {
			records.push(item + '|');
		})
		if(data.subTopics.matches) {
			matches.push(...data.subTopics.matches);
		}
	}*/
	if(data.indicators.results && data.indicators.results.length > 0) {
		data.indicators.results[0].forEach ((item) => {
			records.push(item);
		})
		if(data.indicators.matches) {
			matches.push(...data.indicators.matches);
		}
	}
	const truthyMatches = matches.filter(e => e);
	const uniqMatches = [...new Set(truthyMatches)];

	if(records && records.length > 0) {
		/* Records (topics) */
		let list = [];
		records.forEach ((record) => {
			const top = record.split('|');
			if(!list.includes(top[0])) {
				let matchedName = top[0];
				uniqMatches.forEach((match) => {
					//var re = new RegExp(match, "gi");
					let re = new RegExp(`${match}(?![^<]*>)`, "gi");
					let matched = top[0].match(re);
					matchedName = top[0];
					if(matched) {
						matched.forEach((match) => {
							//let replacement = '<span class="highlight">' + match + '</span>';
							//matchedName = matchedName.replaceAll(re, replacement);
							matchedName = matchedName.replace(re, `<span class="highlight">$&</span>`);
						})
					}
				})
				const obj = {name: top[0], displayName: matchedName, children: []};
				results.push(obj);
				list.push(top[0]);
			}
		})

		//list = [];
		/* Records (subTopics) */
		records.forEach ((record) => {
			const sub = record.split('|');
			if(sub[1]) {
				for (let i = 0; i < results.length; i++) {
					if(results[i].name == sub[0]) {
						let list = [];
						results[i].children.forEach((child) => {
							list.push(child.name);
						})
						if(!list.includes(sub[1])) {
							let matchedName = sub[1];
							uniqMatches.forEach((match) => {
								//let re = new RegExp(match, "gi");
								let re = new RegExp(`${match}(?![^<]*>)`, "gi");
								let matched = sub[1].match(re);
								matchedName = sub[1];
								if(matched) {
									matched.forEach((match) => {
										//let replacement = '<span class="highlight">' + match + '</span>';
										//matchedName = matchedName.replaceAll(re, replacement);
										matchedName = matchedName.replace(re, `<span class="highlight">$&</span>`);
									})
								}
							})
							const obj = {name: sub[1], displayName: matchedName, children: []};
							results[i].children.push(obj);
							list.push(sub[1]);
						}
					}
				}
			}
		})
		//list = [];
		/* Records (indicators) */
		records.forEach ((record) => {
			const sub = record.split('|');
			if(sub[2]) {
				for (let i = 0; i < results.length; i++) {
					if(results[i].name == sub[0]) {
						for (let j = 0; j < results[i].children.length; j++) {
							if(results[i].children[j].name == sub[1]) {
								let list = [];
								results[i].children[j].children.forEach((child) => {
									list.push(child.name);
								})
								if(!list.includes(sub[2])) {
									let matchedName = sub[2];
									uniqMatches.forEach((match) => {
										//var re = new RegExp(match, "gi");
										let re = new RegExp(`${match}(?![^<]*>)`, "gi");
										matchedName = sub[2];
										let matched = sub[2].match(re);
										if(matched) {
											matched.forEach((match) => {
												//let replacement = '<span class="highlight">' + match + '</span>';
												//matchedName = matchedName.replaceAll(re, replacement);
												matchedName = matchedName.replace(re, `<span class="highlight">$&</span>`);
											})
										}
									})
									const obj = {name: sub[2], displayName: matchedName};
									results[i].children[j].children.push(obj);
									list.push(sub[2]);
								}
							}
						}
					}
				}
			}
		})
	}
	return results;
}

function resultToHTML(data) {
	let resultDiv = document.createElement('div');
	const resultObj = resultToSingleObj(data);
	resultObj.forEach((topic) => {
		let divTop = document.createElement('div');
		//divTop.classList.add('search-result-item','search-result-item-h6');
		divTop.classList.add('search-result-item-h6');
		divTop.innerHTML = topic.displayName;
		/*divTop.style.cursor = 'pointer';
		divTop.onclick = function(e) {
					e.preventDefault();
					topicClicked(this);
				};*/
		resultDiv.append(divTop);
		if(topic.children.length > 0) {
			topic.children.forEach((subtopic) => {
				let divSub = document.createElement('div');
				//divSub.classList.add('search-result-item','search-result-item-medium');
				divSub.classList.add('search-result-item-medium');
				divSub.innerHTML = subtopic.displayName;
				/*divSub.style.cursor = 'pointer';
				divSub.onclick = function(e) {
							e.preventDefault();
							topicClicked(this);
						};*/
				resultDiv.append(divSub);
				if(subtopic.children.length > 0) {
					subtopic.children.forEach((indicator) => {
						let divInd = document.createElement('div');
						divInd.classList.add('search-result-item','search-result-item-regular');
						divInd.innerHTML = indicator.displayName;
						divInd.style.cursor = 'pointer';
						divInd.href = baseUrl + "/indicatorsexplorer?iname=" + encodeURIComponent(indicator.name);
						divInd.tabIndex = "0";
						divInd.role="option";
						divInd.onclick = function(e) {
							e.preventDefault();
							window.location = this.href;    
						}
						divInd.onkeydown  = function(e) {
							e.preventDefault();
							//if (e.key === 'Enter') {
							if (['Enter', ' '].includes(e.key)) {
								window.location = this.href;
							} else if(e.key === 'Escape') {
								showResults.value = false; 
								hideSearchResult();
							} else if (['ArrowUp', 'ArrowDown','Tab'].includes(e.key)) {
								// Add your Arrow navigation logic
								const focusableElements = Array.from(document.querySelectorAll('[tabindex]'))
									// Sort them strictly by their tabIndex order (ascending)
									.sort((a, b) => a.tabIndex - b.tabIndex);

								const currentIndex = focusableElements.indexOf(document.activeElement);
								let nextIndex = currentIndex
								if (e.key !== 'ArrowUp') {
									nextIndex = (currentIndex + 1) % focusableElements.length;
								}else {
									nextIndex = (currentIndex - 1) % focusableElements.length;
								}								
								focusableElements[nextIndex].focus();
							}
						}
						divInd.onblur  = function(e) {
							e.preventDefault();
							if(e.relatedTarget && e.relatedTarget.classList && e.relatedTarget.classList.contains('search-result-item')) {
								//do nothing
							} else {								
								hideSearchResult();
							}

						}
						resultDiv.append(divInd);
					})
				}
			})
		}
		
	})
	if(resultDiv.innerHTML === "") {
		noResults.value = true;
	} else {
		noResults.value = false;
	}
	return resultDiv;

}

async function clearInput() {
	searchTerm.value = ''
}
async function getSearchResult() {
	//resultsHtmlObj.value = '';
	if(searchTerm.value && searchTerm.value.trim().length > 0) {
		const sanitizedSearchTerm = searchTerm.value.replace(/[^a-z0-9\s\-&(),]+$/i, "").trim(); 
		const url = apiUrl + '/indicators/api/search?q=' + encodeURIComponent(sanitizedSearchTerm)
		const response = await fetch(url, {
				method: 'GET',
				headers: {'Content-Type': 'application/json', 'x-api-version': version}
			});
		if (!response.ok) {
			throw new Error(`HTTP status: ${response.status}`);
		}
		const data = await response.json();
		const resultDiv = document.querySelector('#search-result');
		resultDiv.innerHTML = '';
		resultDiv.append(resultToHTML(data));

	} else {
		const url = apiUrl + '/indicators/api/search?q='
		const response = await fetch(url, {
				method: 'GET',
				headers: {'Content-Type': 'application/json', 'x-api-version': version}
			});
		if (!response.ok) {
			throw new Error(`HTTP status: ${response.status}`);
		}
		const data = await response.json();
		const resultDiv = document.querySelector('#search-result');
		resultDiv.innerHTML = '';
		resultDiv.append(resultToHTML(data));
	}
}
function topicClicked(elem) {
	const allItems = document.querySelectorAll('.search-result-item');
	let target = 0;
	for(let i=0; i < allItems.length; i++) {
		if(allItems[i] == elem) {
			target = i+1;
			break;
		}
	}
	allItems[target].click();
	/* const firstChild = elem.querySelector('.search-result-item-regular');
	console.log(firstChild);
	if(firstChild) {
		firstChild.click();
	} */
}
const handleBlur = (event) => {
	console.log('handleBlur',event.key)

  // Check if the newly focused element is outside the component container
  if ((event.relatedTarget==null) || (searchContainer.value && !searchContainer.value.contains(event.relatedTarget))) {
    //hideSearchResult()
  }
}

const hideSearchResult = (event) => {
	setTimeout(() => {
		if(route.name !== 'ExplorerView') {
			searchTerm.value = ''
		} else {
			searchTerm.value = props.indName
		}
		showResults.value = false
	}, 300);

}
const handleNoResultsFocus = (event) => {
	isFocused.value = true;
}
const handleNoResultsBlur = (event) => {
	isFocused.value = false;
}
onMounted(() => {
		//wait until DOM is updated, then attach listener
		nextTick(() => {
			const input = document.querySelector('#search-input-home');
			if(input != null) {
				input.addEventListener('focus', (e) => {
					e.preventDefault();
					showResults.value = true;
					clearInput();
					getSearchResult();
				});
				input.addEventListener('blur', (e) => {
					e.preventDefault();
					if(e.relatedTarget && e.relatedTarget.classList && e.relatedTarget.classList.contains('search-result-item')) {
						//do nothing
					} else {
						hideSearchResult();
					}
				});
				input.addEventListener('input', (e) => {
					e.preventDefault();
					showResults.value = true;
					getSearchResult();
				});
				input.addEventListener('keydown', (e) => {
					if (['Enter','ArrowDown'].includes(e.key)) {
						const resultDiv = document.querySelector('#search-result');
						resultDiv.querySelector('[tabindex]').focus();
					}else if (e.key === 'Escape') {
						e.preventDefault();
						showResults.value = false; 
						hideSearchResult();
					}
				});
			}
			const container = document.querySelector('.search-result-wrapper');
			if(container != null) {
				container.addEventListener('blur', (e) => {
					e.preventDefault();
					showResults.value = false; 
					hideSearchResult();
				});
			}
		})


})
// Watch the prop using a getter function
watch(
  () => props.indName,
  (newValue, oldValue) => {
	searchTerm.value = props.indName
  }
)

</script>

<template>
	<section ref:searchContainer class="search-container" > 
		<!-- <label for="search-input-home" class="search-label">
			Search for any related indicators data that may interest you or choose any topic below. 
		</label> -->
		<div class="search-control" >
			<img src="@/assets/images/search.png" class="search-img" alt="search icon" height="16" width="16">
			<input type="text"  
				v-model="searchTerm" 
				class="search-input" 
				id="search-input-home" 
				placeholder="Search for Indicator or by keyword (e.g., workers, publications, etc.)" 
				autocomplete="off"
				tabindex="0"
				:aria-expanded="showResults.toString()"
  				aria-haspopup="listbox"
				aria-controls="search-result"
			/>
		</div>
		<div class="search-result-wrapper">
			<div class="search-results-empty" v-show="(searchTerm && showResults && noResults) || isFocused">
				<span class="no-result-icon"><i class="fa-regular fa-exclamation-circle"></i></span>
				<span class="no-result-title">No Results Found</span>
				<span class="no-result-text">If you can't find what you need, <a class="email_address" href="mailto:ncsesweb@nsf.gov" @focus="handleNoResultsFocus" @blur="handleNoResultsBlur" tabindex="0">contact us</a>. It may be included in future versions.</span>
			</div>
			<div id="search-result" role="listbox" class="search-results" v-show="showResults && !noResults" ></div>
		</div>
	</section>
</template>

<style scoped>
.search-container {
	/*margin-top:2.5rem;*/
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	display: flex;
	/*padding: 0 .5rem;*/
}
.search-label {
	color: var(--text-text-Inverse, #FFF);
	text-align: center;
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/Base */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base, 1rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base, 1.5rem); /* 150% */	
}

.search-img {
	padding: .75rem;
	box-sizing: content-box;
}
.search-control {
	margin-top: .5rem;
	height: 2.5rem;
	max-width: 38.5625rem;
	width: 100%;
	background: var(--surface-Default, #FFF);	
    display: flex;
    justify-content: flex-start;
    align-items: center;
		border-radius: .25rem;
	border: 1px solid var(--borders-input-border, #A9B7C7);
	background: var(--surfaces-surface-default, #FFF);
}

.search-input {
	width:100%;
	height: 100%;
    /*box-sizing: border-box;*/
	border: 0;
	border-radius: 0 25px 25px 0;
}
.search-input:focus, .search-input:active {
    outline: 1.5px solid var(--border-color-input-Active, #064291);
	border-radius: .25rem; 
}
.search-result-wrapper {
	margin-top:.5rem;
	width:100%;
	height: 0;
	max-width: 38.5625rem;
	position: relative;
	z-index: 100;
}
.search-result-wrapper :deep(.search-results-empty) {
	width:100%;
	height:21.5625rem;
	border-radius: 12px;
	border: 1px solid var(--Background-Blue-Gray, #A9B7C7);
	background: var(--surface-Default, #FFF);
	overflow-y: auto;
	/*overflow-y: auto;*/
	display: inline-flex;
	flex-direction: column;
	gap: 1rem;
	/*height: 30.9375rem;*/
	padding: 0 8.5rem;
	justify-content: center;
	align-items: center;
}
.search-result-wrapper :deep(.no-result-icon) {
	color: var(--feedback-info, #005293);
	text-align: center;
	font-family: "Font Awesome 7 Pro";
	font-size: 2.5rem;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	
}
.search-result-wrapper :deep(.no-result-title) {
	color: var(--text-Primary);
	text-align: center;
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/H6 */
	font-family: var(--font-family-Title);
	font-size: var(--font-size-H6);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H6);
	
}
.search-result-wrapper :deep(.no-result-text) {
	color: var(--text-Secondary);
	text-align: center;
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Regular/Base */
	font-family: var(--font-family-Title);
	font-size: var(--font-size-Base);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base);
	
}
.search-result-wrapper :deep(.email_address) {
	color: var(--text-Link, #005699);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;

	/* Medium/Base */
	font-family: var(--font-family-Title);
	font-size: var(--font-size-Base);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-Base);
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-skip-ink: auto;
	text-decoration-thickness: auto;
	text-underline-offset: auto;
	text-underline-position: from-font;
}
.email_address {
    color: var(--text-Link);
    text-decoration: none;
	font-weight: 700;
}
.search-result-wrapper :deep(.email_address:hover) {
    text-decoration: underline;
}
.search-result-wrapper :deep(.search-results) {
	width:100%;
	height:21.5625rem;
	border-radius: 12px;
	border: 1px solid var(--Background-Blue-Gray, #A9B7C7);
	background: var(--surface-Default, #FFF);
	overflow-y: auto;	

}
.search-results :deep(.search-result-list) {
	list-style-type: none;
	line-height: var(--font-line-height-Base, 1.5);
}
.search-results :deep(.search-result-item) {
	font-family: var(--font-family-Title, Roboto);
	font-variant-numeric: lining-nums proportional-nums;
	font-feature-settings: 'liga' off, 'clig' off;
	font-style: normal;
	background: var(--surface-color-Default);
}
.search-results :deep(.highlight) {
	/*background-color: yellow;*/
	font-weight: 700;
}
.search-results :deep(.search-result-item-h6) {
	color: var(--text-Header, #171717);
	font-size: var(--font-size-H6, 20px);
	font-weight: 500;
	padding-left: 1rem;
	line-height: 1.7; /*var(--font-line-height-H6, 28px);*/ /* 140% */
	/*list-style-type: none;*/
}
.search-results :deep(.search-result-item:focus),
.search-results :deep(.search-result-item:focus-visible),
.search-results :deep(.search-result-item:hover) {
	background: var(--brand-color-IndicatorsBlue);
	border: 2px solid var(--brand-color-IndicatorsBlue);
	color: var(--text-Inverse);
	outline: none; 
}
/*.search-results :deep(.search-result-item:focus) {
	border: 2px solid var(--border-color-DividerActive);
}*/
.search-results :deep(.search-result-item-medium) {
	color: var(--text-Primary, #2C2C2C);
	font-size: var(--font-size-Base, 16px);
	font-weight: 500;
	padding-left: 2rem;
	line-height: 2;/*var(--font-line-height-Base, 24px);*/ /* 150% */
}
.search-results :deep(.search-result-item-regular) {
	color: var(--text-Primary, #2C2C2C);
	font-size: var(--font-size-Base, 16px);
	font-weight: 400;
	padding-left: 3rem;
	line-height: 2; /*var(--font-line-height-Base, 24px);*/ /* 150% */
}
  /* 499px - Mobile phone */
@media screen and (max-width: 31.1875rem) {
	.search-control {
    	max-width: 90%;
  	}
}

</style>